const events = ['fileProgress', 'fileSuccess', 'fileComplete', 'fileError']

export default events



// WEBPACK FOOTER //
// ./packages/SrBigUpload/common/file-events.js